export default __webpack_public_path__ + "static/media/imghomepagebanner 5.c383968e.png";